/**
 * The headings the reader's rail lists as "this lesson's sections" (`LN-UI05`,
 * docs/35 §5 item 1).
 *
 * A lesson's sections are its `h2`s. A project brief has none: its sections are
 * `h3`s (`LN-ASG02`), so a lesson with no `h2` lists its `h3`s instead, the same
 * rule the server's locked-lesson outline follows (`learn-lesson-teaser.ts`).
 * Headings inside a problem, a worked example or the checkpoint belong to that
 * block, not to the lesson, at either level.
 */
const NOT_A_SECTION = "[data-pc-checkpoint], .pc-exercise, .pc-example";

function headingsAt(root: HTMLElement, tag: "h2" | "h3"): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(tag)).filter(
    (heading) => !heading.closest(NOT_A_SECTION) && Boolean(heading.textContent?.trim()),
  );
}

export function sectionHeadings(root: HTMLElement): HTMLElement[] {
  const h2 = headingsAt(root, "h2");
  return h2.length > 0 ? h2 : headingsAt(root, "h3");
}

/**
 * A heading's name in the rail (`LN-WEB02`): its text without the level chip
 * a topic module's `h2` may end with (`.pc-level`, `STYLE_GUIDE.md` §3), which
 * read as "reserve and shrink_to_fitIntermediate" when the rail took the whole
 * `textContent`.
 */
export function sectionLabel(heading: HTMLElement): string {
  const walker = heading.ownerDocument.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
  let text = "";
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (!node.parentElement?.closest(".pc-level")) text += node.textContent ?? "";
  }
  return text.trim();
}
